export { CuiDescriptionLayout } from './DescriptionLayout';



// WEBPACK FOOTER //
// ./ui/components/descriptionLayout/index.js